// src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import useAccess from "./hooks/useAccess";
import { isAdmin } from "./utils/accessUtils";

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp < Date.now() / 1000;
  } catch {
    return true;
  }
};

const ProtectedRoute = ({
  children,
  adminOnly = false,
  page,
  resource,
  action,
}) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");

  const { hasPermission } = useAccess();

  // 1️⃣ No login
  if (!userId || !token) return <Navigate to="/" replace />;

  // 2️⃣ Token expired
  if (isTokenExpired(token)) {
    localStorage.clear();
    alert("⏰ Session expired, please log in again.");
    return <Navigate to="/" replace />;
  }

  // 3️⃣ Admin-only pages → normal users blocked immediately
  if (adminOnly && !isAdmin(userRole)) {
    return (
      <div className="container py-5 text-center">
        <h4 className="text-danger">Access Denied</h4>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }

  // 4️⃣ Permission check (ONLY for admins)
  if (isAdmin(userRole) && page && resource && action) {
    const allowed = hasPermission(page, resource, action);
    if (!allowed) {
      return (
        <div className="container py-5 text-center">
          <h4 className="text-danger">Access Denied</h4>
          <p>You do not have permission to view this page.</p>
        </div>
      );
    }
  }

  // 5️⃣ Everything allowed
  return children;
};

export default ProtectedRoute;
